interface ResolveDefaultDocumentsChildParams {
  hasCompanyDocuments: boolean;
  hasCompanyPermission: boolean;
  hasCaePermission: boolean;
  hasSubmittedPermission: boolean;
}

/**
 * Determines the first available documents child route.
 *
 * Priority: company → cae → submitted-documents.
 * Returns null when no child route is available.
 */
export function resolveDefaultDocumentsChild({
  hasCompanyDocuments,
  hasCompanyPermission,
  hasCaePermission,
  hasSubmittedPermission,
}: ResolveDefaultDocumentsChildParams): string | null {
  if (hasCompanyPermission && hasCompanyDocuments) return 'company';
  if (hasCaePermission) return 'cae';
  if (hasSubmittedPermission) return 'submitted-documents';
  return null;
}
